import {
	BackTop,
	Breadcrumb,
	Button,
	Card,
	Col,
	DatePicker,
	Row,
	Select,
	Space,
	Spin,
	Table
} from "antd";
import Loader from "../../Common/Cred/Loader";
import constants from "../../../constants/constants";
import { EditOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { fetchAdminApi } from "../../../services/api";
import { useHistory } from "react-router";
import moment from "moment";
import { registrationFilter } from "../../../globalFunctions/GlobalFunctions";
const { Option } = Select;
const Version = () => {
	const [dataSource, setDataSource] = useState([]);
	const [endDate, setEndDate] = useState(constants.endDateOfTheYear);
	const [startDate, setStartDate] = useState(constants.startDateOfTheYear);
	let history = useHistory();
	useEffect(() => {
		settingsData();
	}, [endDate, startDate]);
	const settingsData = () => {
		let payload = {
			start_date: startDate,
			end_date: endDate,
		};
		fetchAdminApi('/get-version-summary', "POST", payload)
			.then((res) => {
				if (res.code === 200) {
					setDataSource(res.data);
				} else {
					setDataSource([]);
				}
			});
	};
	const columns = [
		{
			title: 'Action',
			align: 'center',
			render: (record) => (
				<Button
					type="text"
					icon={<EditOutlined/>}
					onClick={() => {
						sessionStorage.setItem("editVersionData",JSON.stringify(record));
						sessionStorage.setItem("isEditVersion","true");
						window.open(constants.BaseUrl + "/edit-version-log","_blank");
					}}
				/>
			),
		},
		{
			title: "#",
			key: 'no',
			width: "3%",
			align: 'center',
			render: (text, record, index) => index + 1,
		},
		{
			title: "Type",
			dataIndex: "type",
		},
		{
			title: "Build No.",
			dataIndex: "build_number",
		},
		{
			title: "Task",
			dataIndex: "tasks",
			width: "75%",
			render: (text) => (
				<div
					dangerouslySetInnerHTML={{ __html: text || "-" }}
				/>
			),
		},
		{
			title: "Release Date",
			dataIndex: "release_date",
			render: (release_date) => (
				<span>
					{release_date ? moment(release_date).format("MM/DD/YYYY") : "-"}
				</span>
			),
		},
	];
	const onChangeDateFilter = (e) => {
		registrationFilter(e,setStartDateEndDate);
	};
	const setStartDateEndDate = (startDate,endDate) => {
		setStartDate(startDate);
		setEndDate(endDate);
	};
	const from = (date) => {
		setStartDate(date ? date.format("YYYY-MM-DD") : "");
	};
	const to = (date) => {
		setEndDate(date ? date.format("YYYY-MM-DD") : "");
	};
	const disabledFutureDate = (current) => {
		return current && current > moment().endOf('day');
	};
	const disabledPastDate = (current) => {
		const startdate = moment(startDate);
		const today = moment().endOf("day");
		return !(startdate.isSameOrBefore(current) && today.isAfter(current));
	};
	return (
		<>
			<Spin size="large" spinning={false} indicator={<Loader/>}>
				<div className="div">
					<div className="p-3">
						<Breadcrumb>
							<Breadcrumb.Item>
								<a
									onClick={() => {
										history.push({ pathname: "/admin-dashboard" });
									}}
								>{constants.Home}
								</a>
							</Breadcrumb.Item>
							<Breadcrumb.Item>
								<a
									onClick={() => {
										history.push({ pathname: "/masters-menu" });
									}}
								>{constants.Masters}
								</a>
							</Breadcrumb.Item>
							<Breadcrumb.Item>{constants.Version}</Breadcrumb.Item>
						</Breadcrumb>
					</div>
					<BackTop/>
					<Row gutter={[24, 24]}>
						<Col xs={24} sm={24} md={24} lg={24}>
							<Card
								size="small"
								title={
									<span className="text-uppercase">{constants.Version}</span>
								}
								extra={
									<Space>
										<label
											style={{
												fontWeight: "normal",
												textTransform: "none" 
											}}>{constants.From}</label><DatePicker value={startDate ? moment(startDate) : null} onChange={from} disabledDate={disabledFutureDate} format="MM/DD/YYYY" inputReadOnly={true}/>
										<label 
											style={{
												fontWeight: "normal",
												textTransform: "none" 
											}}>{constants.To}</label><DatePicker value={endDate ? moment(endDate) : null} onChange={to} disabledDate={disabledPastDate} format="MM/DD/YYYY" inputReadOnly={true}/>
										<Select defaultValue="0" style={{ width: 200 }} onChange={onChangeDateFilter} placeholder="Select period" >
											<Option value="0">{constants.ThisYear}</Option>
											<Option value="7">{constants.LastYear}</Option>
											<Option value="1">{constants.ThisMonth}</Option>
											<Option value="2">{constants.LastMonth}</Option>
											<Option value="3">{constants.Last3Months}</Option>
											<Option value="6">{constants.PreviousYears}</Option>
										</Select>
										<Button className="edit-butoon" onClick={() => {
											sessionStorage.removeItem("editVersionData");
											sessionStorage.removeItem("isEditVersion");
											history.push({ pathname: "/add-version-log" });
										}}>{constants.AddVersionLog}</Button></Space>
								}
							>
								<span className="px-3">{ `${dataSource !== null?dataSource.length:0} record(s) found.` }</span>
								<Row gutter={[24, 24]}>
									<Col xs={24} sm={24} md={24} lg={24}>
										<>
											<Table
												rowKey="settings_id"
												className="admin-gap-table table-content-top"
												columns={columns}
												dataSource={dataSource}
												locale={{ emptyText: "No Records Found" }}
												pagination={{ showSizeChanger:true }}
											/>
										</>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
				</div>
			</Spin>
		</>
	);
};
export default Version;
